// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import config from '../../config/config';

// Define a service using a base URL and expected endpoints
export const businessPerformanceAPI = createApi({
  reducerPath: 'businessPerformanceAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getBusinessPerformanceSummary: builder.query<any, businessPerformanceArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/businessperformance/summary`,
        method: 'POST',
        data: payload,
      }),
    }),
    getBusinessPerformanceDetails: builder.query<any, businessPerformanceArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/businessperformance/detail`,
        method: 'POST',
        data: payload,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetBusinessPerformanceSummaryQuery, useGetBusinessPerformanceDetailsQuery } =
  businessPerformanceAPI;
